import { CustomFunctionsParams, SectionSchema } from "@maslul/common-services";
import { EventsCallBackService } from "../../services/fields/events-callback";


export class MICustomFunctionsParams extends CustomFunctionsParams {

    //סכימה כפי שנשלף מהמונגו
    sectionsSchema: Array<SectionSchema> = new Array<SectionSchema>();;
    sectionSchema: SectionSchema = new SectionSchema();

    //repeat
    isInRepeat: boolean = false;
    //index for repeat fields
    eventsCallBackService = EventsCallBackService;

}